import React from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { landingPathForRole } from '../lib/routeConfig';

// Root route (/): decides where to send the visitor based on session state.
//  - Session exists  -> role-based landing (all roles → /dashboard; cc_agent
//    gets the "Mon Dashboard" variant, super_admin/manager the full one).
//  - No session      -> /login
export default function IndexRedirect() {
    const navigate = useNavigate();

    React.useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const me = await api.me();
                if (cancelled) return;
                navigate(landingPathForRole(me.role), { replace: true });
            } catch (_) {
                if (cancelled) return;
                navigate('/login', { replace: true });
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [navigate]);

    return (
        <main
            data-testid="index-redirect"
            className="min-h-screen w-full bg-[#F5F6FA] flex items-center justify-center"
        >
            <div className="text-[#6B7280] text-sm">Chargement…</div>
        </main>
    );
}
